module.exports = __webpack_public_path__ + "static/media/collection-bird-03-effect.64f1f0b8.png";